import styled, { css } from "styled-components";

export type ButtonVariant = "primary" | "secondary" | "ghost";

const variantStyles = {
  primary: css`
    background: ${({ theme }) => theme.color.accent};
    color: white;
    border: 1px solid ${({ theme }) => theme.color.accent};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.color.accentHover};
      border-color: ${({ theme }) => theme.color.accentHover};
    }
  `,
  secondary: css`
    background: ${({ theme }) => theme.color.surface};
    color: ${({ theme }) => theme.color.textPrimary};
    border: 1px solid ${({ theme }) => theme.color.borderStrong};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.color.background};
    }
  `,
  ghost: css`
    background: transparent;
    color: ${({ theme }) => theme.color.textMuted};
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.color.textPrimary};
      background: ${({ theme }) => theme.color.background};
    }
  `,
};

export const Button = styled.button<{ $variant?: ButtonVariant }>`
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};
  border-radius: ${({ theme }) => theme.radius.sm};
  cursor: pointer;
  transition: background 120ms, border-color 120ms, color 120ms;
  white-space: nowrap;

  ${({ $variant = "primary" }) => variantStyles[$variant]}

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.accent};
    outline-offset: 2px;
  }
`;
